import React from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { AddUserDrawerModal } from "@src/components/organisms/modals/add-user-drawer-modal/add-user-drawer-modal";

export const AddUserDrawer = () => {
  const showAddUserDrawerModal = useSelector(
    (state: RootState) => state.yourSlice.modals.addUserDrawerModal.showModal,
  );

  return <>{showAddUserDrawerModal && <AddUserDrawerModal />}</>;
};
